// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.Search_input__sppeS{
    color: white;
    background-color: #0f1127;
    

    border: 0;
    padding: 0 0 0 10px;
    line-height: 50px;
    font-size: 1rem;
    border-radius: 10px;
    outline: 0;
    font-family: 'Poppins', sans-serif;
    letter-spacing: 0.5px;
    width: 300px;
}
.Search_input__sppeS::placeholder{
    color:white;
    font-family: Popins,sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/Pages/SlotsIgrator/components/UI/Search/Search.module.css"],"names":[],"mappings":";AACA;IACI,YAAY;IACZ,yBAAyB;;;IAGzB,SAAS;IACT,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,UAAU;IACV,kCAAkC;IAClC,qBAAqB;IACrB,YAAY;AAChB;AACA;IACI,WAAW;IACX,8BAA8B;AAClC","sourcesContent":["\n.input{\n    color: white;\n    background-color: #0f1127;\n    \n\n    border: 0;\n    padding: 0 0 0 10px;\n    line-height: 50px;\n    font-size: 1rem;\n    border-radius: 10px;\n    outline: 0;\n    font-family: 'Poppins', sans-serif;\n    letter-spacing: 0.5px;\n    width: 300px;\n}\n.input::placeholder{\n    color:white;\n    font-family: Popins,sans-serif;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `Search_input__sppeS`
};
export default ___CSS_LOADER_EXPORT___;
